import React from "react";

const Header = ({ children, noScroll = false }) => {
	return <div className={"analytics-header" + (noScroll ? " no-scroll" : "")}>{children}</div>;
};
export default Header;
